// @ts-nocheck
import React, { useState } from 'react';
import MapViewerReact from '../MapViewerReact';
import MapViewerReactMulti from '../MapViewerReactMulti';
import { point } from '@turf/turf';
import { useDispatch } from 'react-redux';
import { modalViewsConst, setModalState } from '../../store/modalSlice';

import Select from "../ReusableComponents/Select";
const QSAssetsOverview = ({onSubmit, onCancel, llmResponse, onHandlePrevious, onCompleteForm, assetGroupList, onAssetGroupChange, selectedAssetGroup }) => {
  const { justification, assetGroup, assets, windEnergyModels } = llmResponse
  console.log("llmResponse", llmResponse)
  const dispatch = useDispatch()
  const [currentAsset, setCurrentAsset] = useState("overview"); // "overview" | assetId | "complete"

  // Convert the `assets` dictionary keys to an array
  const allAssetIds = Object.keys(assets || {});


  console.log("assetGroupList", assetGroupList)

  const handleNext = () => {
    // If we are at "overview", go to the first asset (if any)
    if (currentAsset === "overview") {
      if (allAssetIds.length > 0) {
        setCurrentAsset(allAssetIds[0]);
      } else {
        // If no assets at all, maybe go straight to "complete"
        setCurrentAsset("complete");
      }
      return;
    }

    // If we are currently on "complete", do nothing (or handle differently)
    if (currentAsset === "complete") {
      return;
    }

    // Otherwise, we're on some asset. Find its index in the array
    const currentIndex = allAssetIds.indexOf(currentAsset);
    const newIndex = currentIndex + 1;

    // If next index is beyond the array, go to "complete"
    if (newIndex >= allAssetIds.length) {
      setCurrentAsset("complete");
    } else {
      setCurrentAsset(allAssetIds[newIndex]);
    }
  };

  const handlePrevious = () => {
    // If we are at "overview", there's nowhere "before" that, so do nothing
    if (currentAsset === "overview") {
      onHandlePrevious()
      return;
    }

    // If we are at "complete", go back to the last asset
    if (currentAsset === "complete") {
      if (allAssetIds.length > 0) {
        setCurrentAsset(allAssetIds[allAssetIds.length - 1]);
      } else {
        // If no assets, maybe go to "overview"
        setCurrentAsset("overview");
      }
      return;
    }

    // Otherwise, we are on some asset. Find its index.
    const currentIndex = allAssetIds.indexOf(currentAsset);
    const newIndex = currentIndex - 1;

    // If we move before the first asset, go to "overview"
    if (newIndex < 0) {
      setCurrentAsset("overview");
    } else {
      setCurrentAsset(allAssetIds[newIndex]);
    }
  };

  const handleCompleteForm = () => {
    console.log("test")
    onCompleteForm()
  }

  const handlePreviewWind = (pCurveRecord) => {
    dispatch(
          setModalState({
            modalOpen: true,
            modalView: modalViewsConst.powerCurveGraph,
            properties: {
              ...pCurveRecord,
              modalType: 'callback' // Add modalType to let editors know this is callback mode
            },
          })
        );
  }

  const handlePreviewAsset = () => {
    // Only proceed if we have a current asset selected
    if (currentAsset !== "overview" && currentAsset !== "complete" && currentAssetObj) {
      dispatch(
        setModalState({
          modalOpen: true,
          modalView: modalViewsConst.assetCallback,
          properties: {
            ...currentAssetObj,
            // modalType: 'callback'
          },
        })
      );
    }
  }

  // const assetGroupCount = assetGroup ? 1 : 0;
  const assetsCount = assets ? Object.keys(assets).length : 0;
  const windCurveCount = windEnergyModels ? Object.keys(windEnergyModels).length : 0;
  
  // Craig move to util - Utility to build one FeatureCollection of all assets + array of points
  function getFeatureCollections(assetsDict) {
    if (!assetsDict) {
      return { points: [], featureCollection: { type: "FeatureCollection", features: [] } };
    }
    const points = [];
    const features = Object.values(assetsDict).map((asset) => {
      const { lat, lng, ...rest } = asset;
      points.push({ lng, lat });
      return {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [lng, lat],
        },
        properties: {
          ...rest,
        },
      };
    });

    return {
      points,
      featureCollection: {
        type: "FeatureCollection",
        features,
      },
    };
  }

  const handleAssetGroupChange = (e) => {
    // console.log("event", e.target.value)
    const allAssetGroups = [ llmResponse?.assetGroup, ...assetGroupList ]
    // console.log("allAssetGroups",allAssetGroups)
    const updatedSelectedAssetGroup = allAssetGroups.find(({id}) => id === e.target.value)
    // console.log("updatedSelectedAssetGroup", updatedSelectedAssetGroup)
    onAssetGroupChange({assetGroup:updatedSelectedAssetGroup})
  }

  const renderDetails = () => {
    if(currentAsset === "overview" || currentAsset === "complete") {
      return (<>
      <h2 className="text-xl font-bold mb-2">Overview</h2>
      <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
        Details: {justification}
          </div>
        <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px] flex">
        <span>Asset Group:</span>
        <Select
          id="my-select"
          value={selectedAssetGroup?.id}
          onChange={handleAssetGroupChange}
          containerClassName="mx-2"
        >
          {/* Craig here put all asset group, make created default the selected one */}
          <option value={llmResponse?.assetGroup?.id}>{llmResponse?.assetGroup?.name} (New Group)</option>
          {assetGroupList.map(({id, name, organizationId}) => <option disabled={Boolean(organizationId)} key={id} value={id}>{name} {organizationId ? "- Organization group" :""}</option>)}
        </Select>
        </div>
        <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
        Assets: {assetsCount}
          </div>
        <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
        Wind Energy Models: {windCurveCount}
          </div>
          <div className=" text-sm text-white mb-2 font-['Inter'] leading-[18px]">
        {/* Wind Energy Models: {windCurveCount} */} {" x "}
          </div>
          <div className="text-white text-sm mb-2 font-['Inter'] leading-[18px]">
        {/* Wind Energy Models: {windCurveCount} */} {" x"}
          </div>
      </>)
    } else if(currentAsset === "complete") {
      return <div>Complete</div>
    }
    const currentAssetObj = assets?.[currentAsset]
    if(currentAssetObj) {
      return(
        <>
        <h2 className="text-xl font-bold mb-2">{currentAssetObj.name}</h2>
            <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
                Justification: {currentAssetObj.justification}
            </div>
            <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
            description: {currentAssetObj.description}
              </div>
            <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
            Latitude: {currentAssetObj.lat}
              </div>
            <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
              Longitude: {currentAssetObj.lng}
            </div>
            <div onClick={()=>handlePreviewAsset()} className="cursor-pointer underline text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
              Preview Asset
            </div>
              {
              currentAssetObj?.windCurveId ?

              <div onClick={()=>handlePreviewWind(windEnergyModels?.[currentAssetObj?.windCurveId])} className="cursor-pointer underline text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
                Preview Wind Energy Model
              </div>
              :
              <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]">
                Elevation (m): {currentAssetObj.elevation}
              </div>
              
              }
        </>
      )
    } else {
    return(<div>ERROR!</div>)
    }

  }
    

  const handleMapClick = (e) => {
    // Craig next handle feature that was clicked console.log(e)
    
    // console.log("EEExx", e.feature, e.features) console.log("properties", e.features?.[0]?.properties?.id)
    const featureAssetId = e.features?.[0]?.properties?.id
    if(featureAssetId) {
      setCurrentAsset(featureAssetId)
    }
  }
  const { points, featureCollection } = getFeatureCollections(assets);
  const currentAssetObj = assets?.[currentAsset];
  console.log("currentAssetObj", currentAssetObj)
  
  let viewerPoints;

  if(currentAssetObj) {
    // viewerPoints = [currentAssetObj.
    viewerPoints = [{lat:currentAssetObj.lat, lng: currentAssetObj.lng}]
  } else {
    viewerPoints = points
  }
  // console.log("currentAsset x", currentAsset)
  console.log("currentAssetObj", currentAssetObj)
 
  return (
    <div>
      {renderDetails()}
      {/* <h2 className="text-xl font-bold mb-2">Overview</h2> <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]"> Details: {justification} </div> <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]"> Asset Groups: {assetGroupCount} </div> <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]"> Assets: {assetsCount} </div> <div className="text-gray-500 text-sm mb-2 font-['Inter'] leading-[18px]"> Wind Curves: {windCurveCount} </div> */}
        <div className='flex justify-end gap-2 my-4'>
            {/* <button className='eai-btn-red' onClick={onCancel}>Cancel</button> */}
            <button onClick={handleCompleteForm} className='eai-btn-yellow'>Submit</button> 
            <button className='eai-btn-red bg-red-600' onClick={handlePrevious}>Previous</button>
            {currentAsset !== "complete" ? <button className='eai-btn bg-green-600' onClick={handleNext}><span className='px-2'>Next</span></button> : null}
          </div>
      <MapViewerReactMulti
        points={viewerPoints}
        onClick={handleMapClick}
        currentAssetId={currentAssetObj?.id}
        geojsonData={{ genericPointData:featureCollection }}
        offset={10} 
        />
        
    </div>
  )
}

export default QSAssetsOverview